import type { FC, ReactElement } from 'react';

import { Overscrollable } from '../../overscrollable';
import type { BetLimitsProps } from '../types';

import styles from './BetLimits.module.css';

/**
 * @description `BetLimits` component displays bet limit data in different ways, depending on the data structure.
 * @param betLimitData - the data containing the bet limits
 * @param currencySymbol - the currency symbol to display with the bet limits
 * @param footNotes - additional information to display at the bottom of the component
 * @param tableBetLimits - the limits for the table
 * @param tableName - the name of the table
 * @param additionalInformation - additional information to display after BetLimitsTable of the component
 */
export const BetLimits: FC<BetLimitsProps> = ({
  footNotes,
  tableName,
  tableLimit,
  betLimitTable,
  additionalInformation,
}): ReactElement => {
  return (
    <div data-testid="bet-limits" className={styles.betLimits}>
      <Overscrollable>
        <div className={styles.betLimits__limits}>
          <div className={styles.betLimits__header}>
            <span className={styles.betLimits__header__tableName}>{tableName}</span>
            <span className={styles.betLimits__header__limits}>{tableLimit}</span>
          </div>
          {betLimitTable}
          {additionalInformation ?? null}
        </div>
      </Overscrollable>

      {footNotes && footNotes.length > 0 ? (
        <div className={`${styles.betLimits__footer} ${styles.betLimits__footNote}`}>
          {footNotes.map((footNote, i) => (
            <div key={i} className={styles.betLimits__footNote__payout}>
              {footNote}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};
